"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformPoint = exports.distanceFromOrigin = void 0;
var distanceFromOrigin = exports.distanceFromOrigin = function distanceFromOrigin(x, y, originX, originY) {
  return Math.sqrt(Math.pow(x - originX, 2) + Math.pow(y - originY, 2));
};
var transformPoint = exports.transformPoint = function transformPoint(x, y) {
  var originX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var originY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var angleDeg = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var a = angleDeg * Math.PI / 180;
  return {
    x: (x - originX) * Math.cos(a) - (y - originY) * Math.sin(a) + originX,
    y: (x - originX) * Math.sin(a) + (y - originY) * Math.cos(a) + originY
  };
};